var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "how_to_reg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5 12.118C12.71 12.118 14.5 10.3575 14.5 8.18399C14.5 6.01046 12.71 4.25 10.5 4.25C8.29 4.25 6.5 6.01046 6.5 8.18399C6.5 10.3575 8.29 12.118 10.5 12.118ZM10.5 6.217C11.6 6.217 12.5 7.10214 12.5 8.18399C12.5 9.26584 11.6 10.151 10.5 10.151C9.4 10.151 8.5 9.26584 8.5 8.18399C8.5 7.10214 9.4 6.217 10.5 6.217ZM4.5 18.019C4.7 17.3994 7.07 16.3667 9.46 16.111L11.5 14.144C11.11 14.1046 10.82 14.085 10.5 14.085C7.83 14.085 2.5 15.4029 2.5 18.019V19.986H11.5L9.5 18.019H4.5ZM20.1 12.6097L14.97 17.6944L12.9 15.6487L11.5 17.0355L14.97 20.4777L21.5 13.9965L20.1 12.6097Z",
    fill: "#28AD35"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.04789cfedded97b45c8532f6af993ad7.svg";
export { ForwardRef as ReactComponent };